module.exports = __webpack_public_path__ + "static/img/5.ac303d6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/14/sp/5.png
// module id = jDOJ
// module chunks = 0